<script lang="ts">
    import clickSound from '@src/utils/useClickSound.js';

    let className = '';
    export let disabled = true;
    export { className as class };
</script>

<button
    {disabled}
    class="button-wrapper-primary btn-base relative overflow-hidden rounded-full hover:cursor-pointer {className}"
    on:click
    use:clickSound={{ sound: 'audio_play_button', volume: 0.3 }}
>
    <div
        class="cstm-position-center w-full h-full relative bg-btn-main-default bg-contain bg-no-repeat hover:brightness-110 active:shadow-[0px_0px_9px_15px_#0303038c_inset] active:rounded-full"
    >
        <slot />
    </div>
</button>
